import { render, staticRenderFns } from "./OnboardingDialog.vue?vue&type=template&id=3c9eaa17"
import script from "./OnboardingDialog.vue?vue&type=script&lang=js"
export * from "./OnboardingDialog.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDialog.vue?vue&type=style&index=0&id=3c9eaa17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports